var _style, _g, _g2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKuka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 337.4 82.7",
    style: {
      enableBackground: "new 0 0 337.4 82.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "59,13.9 28.1,40 28.1,13.9 11,13.9 11,67.1 28.1,67.1 28.1,40 59,67.1 82.9,67.1 50.1,40 82.9,13.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.2,45.5c0,6.8-2.5,8.7-9.5,8.7h-16.9c-7,0-9.5-2-9.5-8.7V14h-17v34.6c0,13.2,7.1,19.5,22.7,19.5h24.3 c15.6,0.1,22.8-6.2,22.8-19.5V14h-17L143.2,45.5L143.2,45.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "173.4,13.9 173.4,67.1 190.5,67.1 190.5,40 190.5,13.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.7,13.9h-15L245.3,67l-32.7-27l32.8-26.1h-24L190.4,40l30.9,27h23.9h0.1h19.4l5.6-9.2h31.4l5.6,9.2H327 L293.7,13.9z M276.3,47.2l9.9-16.9l9.9,16.9H276.3z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13.9,
    className: "st0",
    width: 17.1,
    height: 53.2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 173.4,
    y: 13.9,
    className: "st0",
    width: 17.1,
    height: 53.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuka);
export default __webpack_public_path__ + "static/media/kuka.bbf0502f3721a041d3fba72c6e4e8221.svg";
export { ForwardRef as ReactComponent };